import { HealthDashboard } from "health-dashboard";
import "health-dashboard/styles.css";
import { useEffect, useMemo, useState } from "react";
import { useGetCustomers } from "../../common/hooks/useGetCustomers";
import { useGetLocations } from "../../common/hooks/useGetLocations";
import { getIdToken } from "../../common/utils/getJwtToken";
import { env } from "../../configs/reexports";

// Cube.js API URL - dynamically constructed based on environment
const CUBE_API_URL = `https://cube.${env.stacks.webapp.domain.apex}/cubejs-api/v1`;

export default function SystemHealthPage() {
  const { customers } = useGetCustomers();
  const { locations } = useGetLocations();
  const [cubeToken, setCubeToken] = useState<string>("");

  useEffect(() => {
    const fetchToken = async () => {
      try {
        const token = await getIdToken();

        setCubeToken(token);
      } catch (error) {
        console.error("Failed to get auth token for Cube.js:", error);
      }
    };

    fetchToken();
  }, []);

  const filterOptions = useMemo(
    () => ({
      tenants:
        customers?.items?.map(customer => ({
          value: customer.id || "",
          label: customer.name || "",
        })) ?? [],

      facilities:
        locations?.items?.map(location => ({
          value: location.id || "",
          label: location.name || "",
        })) ?? [],
    }),
    [customers?.items, locations?.items]
  );

  if (!cubeToken) {
    return <div>Loading...</div>;
  }

  return (
    <HealthDashboard
      cubeApiUrl={CUBE_API_URL}
      cubeApiToken={cubeToken}
      filterOptions={filterOptions}
    />
  );
}
